import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useHeaderStore = defineStore({
    id: 'header',
    state: () => ({
        menuList: [{
            id: 'corporate', label: "sitemap.corporate",
            navbarList: [{ id: 'aboutcorporate', label: 'sitemap.aboutcorporate'}, { id: 'corpvaccination', label: 'sitemap.vaccinations' }, { id: 'corptelemedicine', label: 'sitemap.telemedicines' }],
        },
        {
            id: 'insurer', label: "sitemap.insurer",
            navbarList: [{ id: 'aboutinsurer', label: 'sitemap.aboutinsurer'}, { id: 'tpa', label: 'sitemap.tpa' }, { id: 'insucheckupservices', label: 'sitemap.checkupServices' }, { id: 'insuvaccination', label: 'sitemap.vaccinations' }, { id: 'insutelemedicine', label: 'sitemap.telemedicines' }, 
                // { id: 'emergencyassistance', label: 'sitemap.emergencyAss' }, 
                { id: 'insunursingservices', label: 'sitemap.nursingServ' }]
        },
        {
            id: 'patients', label: "sitemap.patients",
            navbarList: [{ id: 'aboutpatients', label: 'sitemap.aboutpatients'},{ id: 'paticheckupservices', label: 'sitemap.checkupServices' }, { id: 'pativaccination', label: 'sitemap.vaccinations' }, { id: 'patitelemedicine', label: 'sitemap.telemedicines' }, 
                // { id: 'emergencyassistance', label: 'sitemap.emergencyAss' }, 
                { id: 'patinursingservices', label: 'sitemap.nursingServ' }]
        },
        //{ id: 'checkupcentre', label: 'sitemap.centreNameOnly' }, 
        {
            id: 'services', label: "sitemap.services",
            navbarList: [{ id: 'aboutservices', label: 'sitemap.aboutservices'},{ id: 'servcheckupservices', label: 'sitemap.checkupServices' }, { id: 'factsheet', label: "sitemap.factSheet" }]
        },
        {
            id: 'aboutus', label: "sitemap.aboutus",
            // navbarList: [{ id: 'ourvalues', label: 'sitemap.ourValues' }, { id: 'ourteam', label: 'sitemap.ourTeam' }, { id: 'ourservices', label: 'sitemap.ourServ' }, { id: 'ourfacilities', label: 'sitemap.ourFac' }]
        },
        // { id: 'investorrelations', label: "sitemap.investorrelation" },
        { id: 'workwithus', label: "sitemap.workWithUs" },],
        selectedMenu: {},
        currentMenu: {},
        scrollPosition: 0,
        routerName: null,
        scrollToAppointmentForm: false,
        isShowFormalStatement:true,
        isShowSmallIcon: false,
        winowWidthToShowSmallLogo: 1400,
    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useHeaderStore, import.meta.hot));
}

export { useHeaderStore };
